export default __webpack_public_path__ + "static/media/business-bay-1.40682c5d.webp";